import { InjectionToken } from '@angular/core';

export const SELFAI_APP_BASE_HREF = new InjectionToken<string>('selfaiAppBaseHref', {
  factory: () => {
    return '/';
  },
  providedIn: 'root',
});
